var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassbookIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 49,
    viewBox: "0 0 80 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_241_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70.0363V41H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45786 6.42654C9.45786 6.6742 9.36521 6.86557 9.18077 7.00152C8.99546 7.13574 8.73828 7.20242 8.40836 7.20242H7.04712V4.4834H8.29406C8.62398 4.4834 8.87423 4.54142 9.04568 4.65658C9.21627 4.77262 9.302 4.94234 9.302 5.16575C9.302 5.32075 9.2587 5.45151 9.17384 5.55715C9.08811 5.66366 8.95736 5.73553 8.78244 5.7719C9.00152 5.79788 9.16864 5.86715 9.28468 5.97972C9.39985 6.09316 9.45786 6.2421 9.45786 6.42654ZM8.73048 5.24542C8.73048 5.12332 8.69065 5.03673 8.61272 4.98564C8.53392 4.93282 8.41875 4.90597 8.26635 4.90597H7.61863V5.57793H8.26981C8.43087 5.57793 8.54777 5.55022 8.61965 5.4948C8.69325 5.43938 8.73048 5.35625 8.73048 5.24542ZM8.88635 6.38151C8.88635 6.1278 8.70364 6.00051 8.33908 6.00051H7.61863V6.77984H8.35987C8.54171 6.77984 8.67507 6.7478 8.75819 6.68286C8.84306 6.61618 8.88635 6.51573 8.88635 6.38151Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8225 7.20242L11.5835 6.50621H10.5444L10.3054 7.20242H9.73389L10.728 4.4834H11.3999L12.3871 7.20242H11.8225ZM11.064 4.90251L11.0501 4.94407C11.038 4.99083 11.0233 5.04365 11.0051 5.1034C10.986 5.16142 10.8752 5.48701 10.6726 6.08017H11.4554L11.1852 5.29737L11.1021 5.03413L11.064 4.90251Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4083 7.20242L13.2238 5.11033C13.2463 5.31382 13.2584 5.47662 13.2584 5.59871V7.20242H12.7527V4.4834H13.4039L14.6058 6.59626C14.5824 6.40056 14.5711 6.22218 14.5711 6.06285V4.4834H15.0768V7.20242H14.4083Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4924 7.20242L16.5156 5.95548L16.1797 6.21179V7.20242H15.6082V4.4834H16.1797V5.71648L17.4024 4.4834H18.0674L16.907 5.63335L18.1609 7.20242H17.4924Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7149 7.20242L21.4032 6.40576H20.1667L19.8549 7.20242H19.4705L20.5823 4.4834H20.998L22.0925 7.20242H21.7149ZM20.7867 4.7605L20.7694 4.81592C20.7364 4.92242 20.688 5.05838 20.6239 5.22463L20.2775 6.11827H21.2958L20.946 5.22117C20.9088 5.13371 20.8733 5.03326 20.8386 4.91983L20.7867 4.7605Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6281 4.74177C23.3276 4.74177 23.093 4.83876 22.925 5.03273C22.7587 5.22669 22.6756 5.49253 22.6756 5.82938C22.6756 6.1619 22.7622 6.43033 22.9354 6.63296C23.1103 6.83645 23.3476 6.93777 23.6454 6.93777C24.0264 6.93777 24.3122 6.749 24.5044 6.36972L24.8058 6.52212C24.6923 6.75592 24.5339 6.93344 24.3313 7.05553C24.1304 7.1785 23.8957 7.23911 23.6281 7.23911C23.3528 7.23911 23.1155 7.18283 22.9146 7.06939C22.7154 6.95682 22.563 6.79402 22.4574 6.58101C22.3535 6.36885 22.3015 6.1186 22.3015 5.82938C22.3015 5.39555 22.4175 5.05611 22.6513 4.81105C22.8869 4.56426 23.2107 4.44043 23.6247 4.44043C23.913 4.44043 24.1546 4.49758 24.3486 4.61015C24.5443 4.72359 24.688 4.89244 24.7781 5.11585L24.4282 5.23016C24.3659 5.07342 24.2637 4.95306 24.1234 4.86993C23.9849 4.78507 23.8195 4.74177 23.6281 4.74177Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4802 4.74177C26.1797 4.74177 25.945 4.83876 25.777 5.03273C25.6108 5.22669 25.5276 5.49253 25.5276 5.82938C25.5276 6.1619 25.6142 6.43033 25.7874 6.63296C25.9623 6.83645 26.1996 6.93777 26.4975 6.93777C26.8785 6.93777 27.1643 6.749 27.3565 6.36972L27.6578 6.52212C27.5444 6.75592 27.3859 6.93344 27.1833 7.05553C26.9824 7.1785 26.7477 7.23911 26.4802 7.23911C26.2048 7.23911 25.9675 7.18283 25.7666 7.06939C25.5675 6.95682 25.4151 6.79402 25.3094 6.58101C25.2055 6.36885 25.1536 6.1186 25.1536 5.82938C25.1536 5.39555 25.2696 5.05611 25.5034 4.81105C25.7389 4.56426 26.0628 4.44043 26.4767 4.44043C26.7651 4.44043 27.0067 4.49758 27.2006 4.61015C27.3963 4.72359 27.5401 4.89244 27.6301 5.11585L27.2803 5.23016C27.2179 5.07342 27.1158 4.95306 26.9755 4.86993C26.8369 4.78507 26.6715 4.74177 26.4802 4.74177Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6924 5.82938C30.6924 6.1134 30.6378 6.36279 30.5296 6.57754C30.4205 6.79056 30.2646 6.95422 30.062 7.06939C29.8585 7.18283 29.6186 7.23911 29.3415 7.23911C29.0618 7.23911 28.8202 7.18283 28.6176 7.06939C28.4167 6.95682 28.2617 6.79402 28.1535 6.58101C28.047 6.36626 27.9941 6.116 27.9941 5.82938C27.9941 5.39555 28.1128 5.05611 28.3509 4.81105C28.5882 4.56426 28.9198 4.44043 29.345 4.44043C29.6221 4.44043 29.8619 4.49585 30.0654 4.60669C30.2681 4.71753 30.4231 4.87859 30.5296 5.08814C30.6378 5.29597 30.6924 5.54362 30.6924 5.82938ZM30.3148 5.82938C30.3148 5.48994 30.23 5.22496 30.062 5.03273C29.8931 4.83876 29.6541 4.74177 29.345 4.74177C29.0333 4.74177 28.7917 4.83789 28.6211 5.02926C28.4522 5.2189 28.3682 5.48561 28.3682 5.82938C28.3682 6.17142 28.4531 6.44246 28.6245 6.64335C28.7977 6.84252 29.0367 6.94123 29.3415 6.94123C29.655 6.94123 29.8957 6.84425 30.062 6.65028C30.23 6.45631 30.3148 6.18268 30.3148 5.82938Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2907 7.24052C32.069 7.24052 31.8751 7.20068 31.7088 7.11929C31.5426 7.03875 31.4127 6.92099 31.3209 6.76599C31.2308 6.61185 31.1858 6.42827 31.1858 6.21526V4.4834H31.5529V6.18408C31.5529 6.43174 31.6162 6.61965 31.7434 6.74867C31.8699 6.87856 32.0526 6.94264 32.2907 6.94264C32.5349 6.94264 32.7245 6.87596 32.8588 6.74174C32.9947 6.60839 33.0631 6.41442 33.0631 6.15984V4.4834H33.4303V6.18062C33.4303 6.40056 33.3827 6.58934 33.2883 6.74867C33.1956 6.908 33.064 7.03096 32.8934 7.11582C32.7245 7.19895 32.5237 7.24052 32.2907 7.24052Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8226 7.20242L34.3678 4.88519L34.3782 5.07223L34.3852 5.39782V7.20242H34.0596V4.4834H34.4856L35.9577 6.81448C35.9412 6.56336 35.9334 6.38065 35.9334 6.26721V4.4834H36.266V7.20242H35.8226Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9944 4.78474V7.20242H37.6273V4.78474H36.6956V4.4834H38.9297V4.78474H37.9944Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 8.21289H62.9736V10.9458H7.05884V8.21289Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 9.30469H27.3202V9.85715H10.2173V9.30469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5747 9.30176H59.8172V9.85422H47.5747V9.30176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 10.9463H62.9736V13.6783H7.05884V10.9463Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 12.0371H30.8446V12.5896H10.2173V12.0371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 12.0361H59.8174V12.5877H51.2664V12.0361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 14.7695H27.3202V15.322H10.2173V14.7695Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 14.7695H59.8174V15.322H51.2664V14.7695Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 16.4131H62.9736V19.146H7.05884V16.4131Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 17.5039H30.8446V18.0564H10.2173V17.5039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 17.502H59.8174V18.0544H51.2664V17.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 20.2373H27.3202V20.7898H10.2173V20.2373Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 20.2354H59.8174V20.7878H51.2664V20.2354Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 21.8789H62.9736V24.6109H7.05884V21.8789Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 22.9697H30.8446V23.5213H10.2173V22.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 22.9668H59.8174V23.5193H51.2664V22.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 25.7021H27.3202V26.2546H10.2173V25.7021Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 25.7002H59.8174V26.2527H51.2664V25.7002Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05884 27.3438H62.9736V30.0758H7.05884V27.3438Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2195 28.4346H30.8459V28.987H10.2195V28.4346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 28.4326H59.8174V28.9842H51.2664V28.4326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2195 31.166H27.3216V31.7185H10.2195V31.166Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 31.165H59.8174V31.7175H51.2664V31.165Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06079 32.8076H62.9755V35.5405H7.06079V32.8076Z",
    fill: "#0269AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2195 33.9004H30.8459V34.4529H10.2195V33.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 33.8975H59.8174V34.4499H51.2664V33.8975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2195 36.6328H27.3216V37.1853H10.2195V36.6328Z",
    fill: "#3A3E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2664 36.6328H59.8174V37.1853H51.2664V36.6328Z",
    fill: "#3A3E75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_6753",
    x: 0,
    y: 0,
    width: 79.0364,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_6753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_6753",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassbookIco);
export default __webpack_public_path__ + "static/media/passbookIco.b191c725184b472b23705307a6e8c870.svg";
export { ForwardRef as ReactComponent };